import React from 'react';
import { Outlet } from 'react-router-dom';
import './pagestyles/Markets.css';
import BottomBanner from './BottomBanner';

const Markets = () => {
  // const location = useLocation();
  

  return (
      <>
    <div className="page-container">
      <div className="page-header">
        <h1>Markets</h1>
        <p className="page-subtitle">Global market news, data, and analysis</p>
      </div>

      <Outlet />
      
      <div className="page-content">
        {/* Featured Market Story */}
        <a href="/article/global-markets-rally" className="featured-article" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <div className="featured-image">
            <img src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=600&fit=crop" alt="Stock market trading floor" />
          </div>
          <div className="featured-content">
            
            <h2>Global Markets Rally as Investors Eye Fed Policy Shift</h2>
            <p>Stock markets worldwide surge on expectations of monetary policy adjustments, with major indices hitting new highs amid renewed investor confidence.</p>
            <span className="article-meta">Breaking News</span>
          </div>
        </a>

        {/* Market News Grid */}
        <div className="content-grid">
          <a href="/article/tech-stocks-lead-market-gains" className="article-card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="article-image">
              <img src="https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?w=600&h=400&fit=crop" alt="Stock trading" />
            </div>
            <div className="article-content">
             
              <h2>Tech Stocks Lead Market Gains</h2>
              <p>Major technology companies drive broader market rally as earnings expectations improve and valuations stabilize.</p>
              <span className="article-meta">30 minutes ago</span>
            </div>
          </a>

          <a href="/article/dollar-strengthens" className="article-card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="article-image">
              <img src="https://images.unsplash.com/photo-1621981386829-9b458a2cddde?w=600&h=400&fit=crop" alt="Currency trading" />
            </div>
            <div className="article-content">
              
              <h2>Dollar Strengthens Against Major Currencies</h2>
              <p>The US dollar gains ground as traders reassess interest rate expectations and economic data surprises to the upside.</p>
              <span className="article-meta">1 hour ago</span>
            </div>
          </a>

          <a href="/article/treasury-yields-higher" className="article-card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="article-image">
              <img src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=600&h=400&fit=crop" alt="Trading floor" />
            </div>
            <div className="article-content">
              
              <h2>Treasury Yields Edge Higher</h2>
              <p>Government bond yields rise modestly as investors weigh inflation concerns against central bank policy signals.</p>
              <span className="article-meta">2 hours ago</span>
            </div>
          </a>

          <a href="/article/oil-prices-fluctuate" className="article-card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="article-image">
              <img src="https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=600&h=400&fit=crop" alt="Commodities" />
            </div>
            <div className="article-content">
            
              <h2>Oil Prices Fluctuate on Supply Concerns</h2>
              <p>Crude oil markets remain volatile as geopolitical tensions and production decisions create uncertainty for traders.</p>
              <span className="article-meta">3 hours ago</span>
            </div>
          </a>

          <a href="/article/bitcoin-holds-100k" className="article-card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="article-image">
              <img src="https://images.unsplash.com/photo-1535320903710-d993d3d77d29?w=600&h=400&fit=crop" alt="Cryptocurrency" />
            </div>
            <div className="article-content">
              
              <h2>Bitcoin Holds Above $100K</h2>
              <p>Cryptocurrency markets show resilience as Bitcoin maintains position above six-figure milestone despite regulatory scrutiny.</p>
              <span className="article-meta">4 hours ago</span>
            </div>
          </a>

          <a href="/article/emerging-markets-capital" className="article-card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="article-image">
              <img src="https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=600&h=400&fit=crop" alt="Market analysis" />
            </div>
            <div className="article-content">
              
              <h2>Emerging Markets Attract Fresh Capital</h2>
              <p>Investors increase allocations to emerging market assets as growth prospects brighten and valuations appear attractive.</p>
              <span className="article-meta">5 hours ago</span>
            </div>
          </a>
        </div>
      </div>
    </div>


      {/*  Bottom Subscription Banner */}
        <BottomBanner />
        </>
  

  );
};

export default Markets;
